export function setNotification(element, state, message) {
  const messageContainer = element.closest('[game]').querySelector('[notification-message]')
  messageContainer.innerText = message

  const notification = messageContainer.closest('.slide--notification')
  notification.className = notification.className.replace(/(^|\s)-\w+/g, '') // remove all modifiers
  notification.classList.add(`-${state}`)

  up.reveal(notification, { padding: 30 })
}
